<div class="row no-gutters">
    <div *ngIf="iconsExpanded" id="filter-bg" class="bg-change"></div>
    <div class="col">
        <div class="section-icons-container">
            <div *ngIf="enableFilter" class="icon" (click)="columnFilter = !columnFilter"
                (clickOutside)="onClickedOutside($event)" [ngbTooltip]="translate.instant('buttons.columnsFilter')"
                tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
                <div>
                    <img [src]="'assets/ico/sliders-h-solid.svg'" alt="translate.instant('buttons.columnsFilter')">
                </div>
            </div>
            <div class="buttons-dropdown">

                <div *ngIf="iconsExpanded" id="close-export-dropdown" class="icon mt-2 expanded-icon"
                    style="top: -0.5px;" (click)="iconsExpanded = false;"
                    [ngbTooltip]="translate.instant('buttons.close')" tooltipClass="animation-tooltip" placement="top"
                    container="body" triggers="hover">
                    <div>
                        <img [src]="'assets/ico/close-black.svg'" alt="translate.instant('buttons.close')">
                    </div>
                </div>

                <div class="icon" (click)="showExportOptions()" [ngbTooltip]="translate.instant('buttons.exportData')"
                    tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
                    <div>
                        <img [src]="'assets/ico/download.svg'" alt="translate.instant('buttons.eportData')">
                    </div>
                </div>

                <div *ngIf="iconsExpanded" class="icon mt-2 expanded-icon" style="top: 50px;"
                    (click)="exportCSVEvent.emit(true)" [ngbTooltip]="translate.instant('buttons.exportCSV')"
                    tooltipClass="animation-tooltip" placement="top" container="body" triggers="hover">
                    <div>
                        <img [src]="'assets/ico/csv.svg'" alt="translate.instant('buttons.exportCSV')">
                    </div>
                </div>

                <!--<apc-sheet-export *ngIf="iconsExpanded" style="top: 50px; position: absolute;" (getToken)="getTokenClient($event)" (exportSheetEvent)="exportSheetEvent.emit(true);">
                </apc-sheet-export>-->

                <div *ngIf="iconsExpanded" class="icon mt-2 expanded-icon" style="top: 100px;"
                    (click)="copyToClipboardEvent.emit(true)"
                    [ngbTooltip]="translate.instant('buttons.copyToClipboard')" tooltipClass="animation-tooltip"
                    placement="top" container="body" triggers="hover">
                    <div>
                        <img [src]="'assets/ico/copy-regular-black.svg'"
                            alt="translate.instant('buttons.copyToClipboard')">
                    </div>
                </div>


            </div>


            <div class="icon" (click)="refreshDataEvent.emit(true)"
                [ngbTooltip]="translate.instant('buttons.refreshData')" tooltipClass="animation-tooltip" placement="top"
                container="body" triggers="hover">
                <div>
                    <img [src]="'assets/ico/refresh-icon.svg'" alt="translate.instant('buttons.refreshData')">
                </div>
            </div>

            <a [routerLink]="'/administration/reports-management/report/' + reportId">
                <div *checkPermission="{ type: 'ADMIN' }" class="icon fill-white"
                    [ngbTooltip]="translate.instant('reports.editReport')" tooltipClass="animation-tooltip"
                    placement="top" container="body" triggers="hover">
                    <div [inlineSVG]="'assets/ico/edit.svg'" alt="translate.instant('reports.editReport')"></div>
                </div>
            </a>

        </div>
    </div>
</div>

<div *ngIf="columnFilter" class="column-filter-select">
    <ng-select [multiple]="true" [ngModel]="selectedTableColumns" (change)="selectTableColumnsEvent.emit($event)"
        [items]="columnsToDisplayInDropdown" [dropdownPosition]="'bottom'" [closeOnSelect]="false"
        [isOpen]="columnFilter" class="column-display">
        <ng-template ng-header-tmp>
            <div class="select-utils">
                <span (click)="selectAllColumnsEvent.emit(true)">{{'columnName.selectAll' | translate}}</span> | <span
                    (click)="unselectAllColumnsEvent.emit(true)">{{'columnName.selectNone' | translate}}</span>
            </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index" class="option column-options">
            <div isEllipsisActive class="dropdown-select-wrapper" style="height: 20px !important; margin-top: -6px;">
                <input style="height: 11px;" id={{item.name}} type="checkbox" [ngModel]="item.selected" />&nbsp;
                <span style="max-width: 290px; font-size: 14px;" class="dropdown-select-label">{{item.name}}</span>
            </div>
        </ng-template>
    </ng-select>
</div>